import { render, staticRenderFns } from "./ActionPalette.vue?vue&type=template&id=7f195249&scoped=true"
import script from "./ActionPalette.vue?vue&type=script&lang=js"
export * from "./ActionPalette.vue?vue&type=script&lang=js"
import style0 from "./ActionPalette.vue?vue&type=style&index=0&id=7f195249&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f195249",
  null
  
)

export default component.exports